import { render } from "./itemStockDetail.vue?vue&type=template&id=2fb7fb69"
import script from "./itemStockDetail.vue?vue&type=script&lang=js"
export * from "./itemStockDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__